var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.37 3.79152H2.34003C1.61654 3.79152 1.03003 4.36025 1.03003 5.06182V14.0024C1.03003 14.704 1.61654 15.2727 2.34003 15.2727H17.37C18.0935 15.2727 18.68 14.704 18.68 14.0024V5.06182C18.68 4.36025 18.0935 3.79152 17.37 3.79152Z",
    stroke: "#B5B7C4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02995 5.89576L0.759949 3.52C0.689949 2.85091 1.17995 2.2497 1.86995 2.18182L15.4799 0.73697C16.1699 0.669091 16.7899 1.14424 16.8599 1.81333L17.0799 3.79152",
    stroke: "#B5B7C4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.62 12.1527C15.1723 12.1527 15.62 11.705 15.62 11.1527C15.62 10.6004 15.1723 10.1527 14.62 10.1527C14.0677 10.1527 13.62 10.6004 13.62 11.1527C13.62 11.705 14.0677 12.1527 14.62 12.1527Z",
    fill: "#B5B7C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d301827f1bde48842f6ec7c094fe5135.svg";
export { ForwardRef as ReactComponent };